import { ReactNode, useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { handleSomeProductRF } from 'core/dataProductsRF';

import { Box } from '@mui/material';

import Menu from 'components/views/Menu';
import NavTitle from 'components/views/NavTitle';
import NavSubPage from 'components/views/NavSubPage';
import ModalClube from 'components/views/ModalClube';
import { Banner } from 'components/views/ContainersPage';
import ShoppingCart from 'components/views/ShoppingCart';
import FadeAnimation from 'components/views/FadeAnimation';
import { ButtonRectangle } from 'components/views/form/Button';

import BannerSeguroDesk from 'assets/images/banners/desk/banner-seguro-desk.png';
import BannerUpgradeRf from 'assets/images/banners/desk/banner-upgrade-rf-desk.png';
import BannerClub from 'assets/images/banners/desk/banner-club2-desk.png';

import { ContentBody, ContentNews, ContentShopping, BoxBanner, Stepper, Step, StepLabel, ContentButton, ContainerBodyWebView } from './styles';

type Params = {
    title?: string;
    link?: string;
    isWebView?: boolean;
    children: ReactNode;
    showShoppingCart?: boolean;
    stepActive?: 0 | 1 | 2 | 3 | 4 | false;
}

const steps: Array<string> = [
    'Perfil',
    'Cotação',
    'Pagamento',
    'Agendamento'
];

const stepsPlataform: Array<string> = [
    'Perfil',
    'Cotação'
];

const ContentContainer = ({ title, link, children, showShoppingCart = false, stepActive = false, isWebView = false }: Params) => {
    const { pathname } = useLocation();
    const [isProductRF, setIsProductRF] = useState(false);
    const [showModalClube, setShowModalClube] = useState(false);

    const navigate = useNavigate();

    const { handlePostChooseQuoteItems, selectedCar } = useContext(DataContext);

    useEffect(() => {
        selectedCar && handleSomeProductRF(selectedCar.CD_PRODUTO) ? setIsProductRF(true) : setIsProductRF(false);
    }, [selectedCar]);

    return (
        <>
            <ContentBody sx={{ paddingRight: { xs: '0', md: showShoppingCart ? '2rem' : '0' }, width: { xs: '100%', md: pathname?.includes('planos') ? '100%' : '70%' } }}>
                {title && link &&
                    <NavSubPage title={title} link={link} />
                }
                {stepActive !== false &&
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        marginBottom: { xs: '1.75rem', md: '2rem' },
                        paddingBottom: '.75rem',
                        justifyContent: 'center',
                        borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
                    }}>
                        <Stepper activeStep={stepActive} alternativeLabel>
                            {pathname?.includes('troca-de-servico') ?
                                steps.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))
                                :
                                stepsPlataform.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))
                            }
                        </Stepper>
                    </Box>
                }
                <FadeAnimation>
                    <Box>
                        {children}
                    </Box>
                </FadeAnimation>
                {pathname?.includes('servicos-adicionais') &&
                    <ContentButton>
                        <ButtonRectangle name='CONTINUAR' onClick={() => { handlePostChooseQuoteItems(); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas/troca-de-servico/pagamento`); }} />
                    </ContentButton>
                }
            </ContentBody>

            {showShoppingCart ?
                <ContentShopping>
                    <ShoppingCart isWebView={isWebView} />
                </ContentShopping>
                :
                !pathname?.includes('planos') &&
                <ContentNews>
                    <BoxBanner>
                        <NavTitle title={pathname?.includes('troca-de-servico') ? 'Troca de Plano' : pathname?.includes('troca-de-titularidade') ? 'Troca de Titularidade' : 'Troca de Veículo'} />
                        {pathname?.includes('troca-de-titularidade') ? <></> : <Banner bannerImg={isProductRF ? BannerUpgradeRf : BannerSeguroDesk} link='' />}
                        {pathname?.includes('troca-de-servico') || pathname?.includes('troca-de-veiculo') || pathname?.includes('trocas-em-andamento') ? <></> : <Banner bannerImg={BannerClub} link='' onClick={() => setShowModalClube(true)} />}
                    </BoxBanner>
                </ContentNews>
            }

            <ModalClube openModal={showModalClube} handleClickClosed={() => setShowModalClube(false)} />
        </>
    )
}

const ContainerSubPage = ({ title, link, children, showShoppingCart = false, stepActive = false, isWebView = false }: Params) => {
    return (
        isWebView ?
            <ContainerBodyWebView>
                <ContentContainer title={title} link={link} showShoppingCart={showShoppingCart} stepActive={stepActive} isWebView={isWebView}>
                    {children}
                </ContentContainer>
            </ContainerBodyWebView>
            :
            <Menu>
                <ContentContainer title={title} link={link} showShoppingCart={showShoppingCart} stepActive={stepActive}>
                    {children}
                </ContentContainer>
            </Menu>
    );
}

export default ContainerSubPage;